export const isMobileValid = (input) => {
	let pattern = /^(09)\d{9}$/;
	return pattern.test(input);
};
